import { SubscriptionStoreValue } from 'app/area/user-profile/subscriptions/types';
import { OptionsCodes } from './types';

export const hasOptionsCodes = (optionsCodes: OptionsCodes) =>
  !optionsCodes?.fetching && optionsCodes?.values?.length > 0;

export const hasOptionsValues = (options: SubscriptionStoreValue[]) => options?.length > 0;
